export const environment = {
  production: true,
  companyName: "Buyzone.lk"
};
